// pages/StoryFormPage.js
import React from "react";
import { useSearchParams } from "react-router-dom";
import StoryForm from "../components/StoryForm";

const StoryFormPage = () => {
  const [params] = useSearchParams();
  const initialType = params.get("type") === "interactive" ? "interactive" : "text";
  return <StoryForm initialType={initialType} />;
};

export default StoryFormPage;
